<template>
  <el-drawer v-model="visible" title="企业详情" size="600px">
    <el-form label-width="100px">
      <el-form-item label="企业名称:" prop="fullName">
        <el-input v-model="org.fullName"></el-input>
      </el-form-item>
      <el-form-item label="企业简称:" prop="name">
        <el-input v-model="org.name"></el-input>
      </el-form-item>
      <el-form-item label="LOGO:">
        <el-image v-if="org.logoPath" :src="getFileUrl(org.logoPath)" :preview-src-list="[getFileUrl(org.logoPath)]"
          style="width: 50px; height: 50px">
        </el-image>
      </el-form-item>
      <el-form-item label="联系人:" prop="contactName">
        <el-input v-model="org.contactName"></el-input>
      </el-form-item>
      <el-form-item label="联系电话:" prop="contactPhone">
        <el-input v-model="org.contactPhone"></el-input>
      </el-form-item>
      <el-form-item label="统一信用代码:">
        <el-input v-model="org.unifiedCreditCode"></el-input>
      </el-form-item>
      <el-form-item label="经营范围:">
        <el-input type="textarea" v-model="org.introduce" :rows="5"></el-input>
      </el-form-item>
      <el-form-item label="营业执照:">
        <el-image v-if="org.businessLicensePath" :src="getFileUrl(org.businessLicensePath)"
          :preview-src-list="[getFileUrl(org.businessLicensePath)]" style="width: 200px; height: 200px">
        </el-image>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import { getEnterpriseById } from '@/api/sys/org';
import { getFileUrl } from '@/utils/common';
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    orgUnit: Object,
    modelValue: Boolean
  },
  data() {
    return {
      getFileUrl,
      org: {}
    }
  },
  computed: {
    visible: {
      get() {
          return this.modelValue; 
      },
      set(value) {
          this.$emit('update:modelValue', value); 
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getOrg();
      }
    }
  },
  methods: {
    getOrg() {
      getEnterpriseById(this.orgUnit.id).then(({data}) => {
        this.org = data.data;
      })
    }
  }
})
</script>